<template>
  <div class="container-xl masonry-container d-none d-sm-block">
    <div class="preview-grid" v-if="experience_type === experienceTypes.PICA_STANDARD">
      <div class="card" v-for="(url, index) in slideshowPhotos" :key="index">
        <img class="card-img img-fluid" :src="url" alt="Card image">
      </div>
    </div>
    <ModalSignup :event-name="event_name"/>
  </div>
</template>

<script>
import ModalSignup from '@/components/ModalSignup';
import {experienceTypes} from "@/consts";


export default {
  components: {
    ModalSignup
  },

  props: {
   photos: {
     type: Array,
     required: false
   },
    event_name: {
      type: String,
      required: false
    },
    experience_type: {
      type: String,
      required: false
    }
  },

  computed: {
    experienceTypes() {
      return experienceTypes
    },
    slideshowPhotos() {
      if(this.experience_type !==  experienceTypes.PICA_STANDARD) return []
      let photos = this.photos
      const minLength = 45
      const maxLength = 72
      if (photos) {
        while (photos.length !== 0 && photos.length < minLength) {
          photos.push(...this.photos)
        }
        photos.splice(maxLength - 1)
        return photos
      } else {
        return []
      }
    }
  },

  mounted() {
    this.$bvModal.show('modal-signup')
  }
}
</script>

<style lang="scss">
/* Override background color opacity and remove blur */
.modal-backdrop {
  background-color: rgba(#00001A, 0.72) !important;
  backdrop-filter: saturate(150%) !important;
}

.site-banner {
  display: none !important;
}

</style>
